// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCQ3kkQAoLAa7MQiY5ybGrPa4Kj4yBF1Hk",
  authDomain: "hamador-6119e.firebaseapp.com",
  projectId: "hamador-6119e",
  storageBucket: "hamador-6119e.firebasestorage.app",
  messagingSenderId: "601826798429",
  appId: "1:601826798429:web:7d179182c6ad753b0196b4",
  measurementId: "G-EMY20YH0WE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics only in browser environment
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
  console.log('Firebase Analytics initialized:', analytics);
}

export { analytics };
